<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { EventStatus } from '@/lib/eventStatus'

const props = defineProps<{ status: EventStatus }>()
const { t } = useI18n()
</script>

<template>
    <span
        class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
        :class="{
            'bg-teal-l text-teal-d': props.status === 'upcoming',
            'bg-green-l text-green-text': props.status === 'ongoing',
            'bg-gray-100 text-gray-600': props.status === 'past',
            'bg-gray-50 text-gray-400': props.status === 'unknown'
        }"
    >
        <span
            v-if="props.status === 'ongoing'"
            class="w-1.5 h-1.5 rounded-full bg-green mr-1.5 animate-pulse"
        />
        {{ t(`events.status.${props.status}`) }}
    </span>
</template>
